var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guideBox"},[_c('div',{staticClass:"contant",style:({ height: _vm.Guide.height + 'px', background: _vm.Guide.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }